import {
  MediaType,
  MilestonesGameQuery,
} from '@optools/services/operator-gateway/types/generated/graphql';

export const filterVideoContent = (
  content: NonNullable<MilestonesGameQuery['game']>['content'],
) => {
  return content?.filter(({ mediaState }) => mediaState?.mediaType === MediaType.VIDEO) ?? [];
};
